import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data from "./master_data";

// Rollback: change this to /api/listof_image_result_recently and rebuild FE1.
const RECENT_IMAGES_ENDPOINT = '/api/listof_image_result_recently_v2';
 


// [ { "id": "63040378", "idopd": "62017839", "dockind": "CBC", "text": "LN : 63040378 / ปุย(62017839) / ธีรพัฒน์ พัฒนศิษฏางกูร / Male ", "icon": "fa fa-paw", "dropDisabled": true, "kind": 2, "selected": false },
//   { "id": "63000010", "idopd": "62028058", "dockind": "CBC", "text": "LN : 63000010 / หมูหยอง(62028058) / ธันชนก ตีรณโชติ / Female ", "icon": "fa fa-paw", "dropDisabled": true, "kind": 2, "selected": false },
//   { "id": "PnacyDSVZN", "text": "New Folder", "opened": true, "children":
//                                       [ { "id": "g8dvUy8HfO", "text": "New Folder", "opened": true, "children": [], "selected": false, "kind": 1 } ], "selected": true, "kind": 1 } ]



export default {
    namespaced: true,
    state: {

        listofcytoresultrecently :[],
        first : 10,  // init
        skip :  0,     // init
        step :  10, // step should equl first


        statofcbclast7day :[],
        fetchStatOfCBCLast7dayCompleted : false,


        newsArr : [],



        imagesArrRecently : [],
        imagesLoaded: false,
        imagesLoading: false,
        imagesError: '',
        imagesRequestMode: 'initial',
        imagesHasMore: true,
        imagesSession: 0,
        firstImagesArrRecently : 10,  // init
        skipImagesArrRecently :  0,     // init


        activeTabViewImages : 0,
        isMoreBtnLoading : false,
    },

    getters: {

        // listofcytoresultrecentlyCytology(state){
        //     return state.listofcytoresultrecently.
        // }

    },

    mutations: {
        resetRecentImages(state) {
            state.imagesSession++;
            state.imagesArrRecently = [];
            state.imagesLoaded = false;
            state.imagesLoading = false;
            state.imagesError = '';
            state.imagesHasMore = true;
            state.imagesRequestMode = 'initial';
            state.skipImagesArrRecently = 0;
            state.isMoreBtnLoading = false;
        },
        setImagesRequest(state, { loading, error, mode }) {
            state.imagesLoading = loading;
            state.imagesError = error;
            state.imagesRequestMode = mode;
            state.isMoreBtnLoading = loading;
        },
        acceptRecentImages(state, { rows, offset, more }) {
            state.imagesArrRecently = more ? state.imagesArrRecently.concat(rows) : rows;
            state.skipImagesArrRecently = offset;
            state.imagesLoaded = true;
            state.imagesHasMore = rows.length >= state.firstImagesArrRecently;
        },


        //
        setActiveTabViewImages(state,activeTabViewImages){
            state.activeTabViewImages = activeTabViewImages
        },
        setIsMoreBtnLoading(state,isMoreBtnLoading){
            state.isMoreBtnLoading = isMoreBtnLoading
        },


        // ImagesArrRecently
        setImagesArrRecently(state,data){
            state.imagesArrRecently = state.imagesArrRecently.concat(data)
        },
        setClearImagesArrRecently(state){
            state.imagesArrRecently = []
        },
        setFirstImagesArrRecently(state,firstImagesArrRecently){
            state.firstImagesArrRecently = firstImagesArrRecently
        },
        setSkipImagesArrRecently(state,skipImagesArrRecently){
            state.skipImagesArrRecently = skipImagesArrRecently
        },




        setNewsArr(state,newsArr){
            state.newsArr = newsArr
        },


        setStatofcbclast7day(state,statofcbclast7day){
            state.statofcbclast7day = statofcbclast7day
        },
        setFetchStatOfCBCLast7dayCompleted(state,fetchStatOfCBCLast7dayCompleted){
            state.fetchStatOfCBCLast7dayCompleted = fetchStatOfCBCLast7dayCompleted
        },

        setSkip(state,skip){
            state.skip = skip
        },


        /* eslint-disable no-console */
        setAddArr(state,data){
            state.listofcytoresultrecently =  state.listofcytoresultrecently.concat(data)
        },

        setClearListOfCytoResultRecently(state){
            state.listofcytoresultrecently = []
        }
    },

    actions: {
        async loadRecentImages({ state, commit }, mode = 'initial') {
            if (state.imagesLoading || (mode === 'initial' && state.imagesLoaded)) return;
            if (mode === 'more' && (!state.imagesLoaded || !state.imagesHasMore)) return;
            const token = localStorage.getItem('access_token');
            if (!token) return;
            const session = state.imagesSession;
            const offset = mode === 'more' ? state.skipImagesArrRecently + state.firstImagesArrRecently : 0;
            const current = () => session === state.imagesSession && token === localStorage.getItem('access_token');
            commit('setImagesRequest', { loading: true, error: '', mode });
            let errorMessage = '';
            try {
                const config = getConfigAxios();
                const res = await axios.post(`${getBaseURLforBackEnd()}${RECENT_IMAGES_ENDPOINT}`,
                    { first: state.firstImagesArrRecently, skip: offset },
                    { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } });
                if (current()) commit('acceptRecentImages', { rows: res.data, offset, more: mode === 'more' });
            } catch (error) {
                errorMessage = 'โหลดภาพล่าสุดไม่สำเร็จ กรุณาลองใหม่';
            } finally {
                if (current()) commit('setImagesRequest', { loading: false, error: errorMessage, mode });
            }
        },

        fetchRecentResultsPage(context, { first, skip }) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
            return axios.post(`${getBaseURLforBackEnd()}/api/listofcytoresultrecently`,
                { first, skip }, getConfigAxios()).then(res => res.data);
        },


        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchListOfCytoresultRecentlySequential({
          state,
          commit
        }) {
          const datTo = {
            "first": state.first,
            "skip": state.skip
          };
          axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/listofcytoresultrecently`, datTo, getConfigAxios()).then(res => {
            commit('setAddArr', res.data);
            return res;
          });
        },

        fetchImagesRecentlySequential({
          state,
          commit
        }) {
          const datTo = {
            "first": state.firstImagesArrRecently,
            "skip": state.skipImagesArrRecently
          };
          axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`;
          return axios.post(`${getBaseURLforBackEnd()}${RECENT_IMAGES_ENDPOINT}`, datTo, getConfigAxios()).then(res => {
            commit('setImagesArrRecently', res.data);
            return res;
          });
        },

        fetchStatOfCBCLast7daySequential({
          commit
        }) {
          return axios.post(`${getBaseURLforBackEnd()}/api/statofcbclast7day_v2`, {}, getConfigAxios()).then(res => {
            commit('setStatofcbclast7day', res.data);
            commit('setFetchStatOfCBCLast7dayCompleted', true);
          });
        },

        fetchNewsArrSequential({
          commit
        }) {
          return axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews_v2`, getConfigAxios()).then(res => {
            commit('setNewsArr', res.data);
          });
        },
clearListOfCytoResultRecently({commit}){
            commit('setClearListOfCytoResultRecently')
        },

        produceListOfCytoresultRecently({commit},listofcytoresultrecently){
            commit('setListOfCytoresultRecently', listofcytoresultrecently)
        },
        produceSkip({commit},skip){
            commit('setSkip', skip)
        },
        /* eslint-disable no-console */
        fetchListOfCytoresultRecently({state,commit}) {
            const datTo ={
                "first": state.first,
                "skip": state.skip
            }
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofcytoresultrecently`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setAddArr',res.data)
                        resolve(res)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })

            })
        } ,


        fetchImagesRecently({state,commit}) {
            const datTo ={
                "first": state.firstImagesArrRecently,
                "skip": state.skipImagesArrRecently
            }
            console.log("fetchImagesRecently")
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token }`
                axios.post(`${getBaseURLforBackEnd()}${RECENT_IMAGES_ENDPOINT}`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setImagesArrRecently',res.data)
                        resolve(res)
                    })
                    .catch(err =>{
                        console.log("err")
                        console.log(err)
                    })

            })
        } ,






        fetchStatOfCBCLast7day({commit}){
            return axios.post(`${getBaseURLforBackEnd()}/api/statofcbclast7day_v2`, {}, getConfigAxios())
                .then((res)=>{
                    commit('setStatofcbclast7day',res.data)
                    commit('setFetchStatOfCBCLast7dayCompleted',true)
                })
        } ,


        fetchNewsArr({commit}){
            // axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews` , getConfigAxios())
            axios.post(`${getBaseURLforBackEnd()}/api/listoflabnews_v2` , getConfigAxios())
                .then((res)=>{
                    commit('setNewsArr',res.data)
                })
        },


         


    }
}